module.exports = __webpack_public_path__ + "img/pos.43f39b68.png";